import {COUNTRIES as COMMON_COUNTRIES, COUNTRY_CODES} from 'common/constants/countries'
import React from 'react'

import SelectWithSearch, {SelectOption} from './SelectWithSearch'

interface CountrySelectProps {
  onSelect: (country: string) => void
  selectedValue?: string | null
  theme?: 'light' | 'dark'
}

// Data lives in common/constants/countries.ts; re-exported here for existing importers.
export const COUNTRIES: SelectOption[] = COMMON_COUNTRIES

const CountrySelect: React.FC<CountrySelectProps> = ({
  onSelect,
  selectedValue,
  theme = 'light',
}) => {
  const matchValue = (item: SelectOption, value: string) => {
    return (
      item.value === value ||
      item.label === value ||
      COUNTRY_CODES[value] === item.value ||
      COUNTRY_CODES[value] === item.label
    )
  }

  return (
    <SelectWithSearch
      options={COUNTRIES}
      onSelect={onSelect}
      selectedValue={selectedValue}
      theme={theme}
      placeholder='Search for your country...'
      emptyMessage='No countries found'
      matchValue={matchValue}
    />
  )
}

export default CountrySelect
